export default __webpack_public_path__ + "static/media/media-img-1.4bae17fc.png";